module.exports = __webpack_public_path__ + "img/bottom-left.79771d1a.png";